export default {
    projectList:[],
    magicOtp: null,
    magicOtpLoading: false,
    magicOtpSaving: false
}
